import React from 'react';
import Slider from "react-slick";
import { Button } from 'reactstrap'
import Bg from '../../images/icons/icon_quote_2.svg'
import avatar1 from '../../images/avatar/avatar_11.webp'
import avatar2 from '../../images/avatar/avatar_10.webp'
import avatar3 from '../../images/avatar/avatar_9.webp'
import avatar4 from '../../images/avatar/avatar_8.webp'
import elise1 from '../../images/elise1.png'
import arrowright from '../../images/arrow-right.png'
import casestudy1 from '../../images/casestudy1.png'
import casestudy2 from '../../images/casestudy2.png'
import casestudy3 from '../../images/casestudy3.png'
import casestudy4 from '../../images/casestudy4.png'
import casestudy5 from '../../images/casestudy5.png'
import casestudy6 from '../../images/casestudy6.png'
import casestudy7 from '../../images/casestudy7.png'
import casestudy8 from '../../images/casestudy8.png'
import casestudy9 from '../../images/casestudy9.png'

import { Link } from 'react-router-dom';

const testimonial = [
    {
        id: '01',
        Title: <>Reviving SEO & Building AI Visibility for a Plate Heat Exchanger Manufacturer</>,
        avatar: avatar1,
        image: casestudy1,
        link: '/srj',
    },
    {
        id: '02',
        Title: <>Global Expansion & Growth for Aroma Monk</>,
        avatar: avatar2,
        image: casestudy2,
        link: '/aromamonk',
    },
    {
        id: '03',
        Title: <>B2B Pharma SEO Turnaround for a Private-Label Manufacturer</>,
        avatar: avatar3,
        image: casestudy3,
        link: '/elise',
    },
    {
        id: '04',
        Title: <>Export-Ready Website & AI-First SEO for GNC Exports</>,
        avatar: avatar4,
        image: casestudy4,
        link: '/gnc',
    },
    {
        id: '05',
        Title: <>Organic Growth & CAC Reduction for Ease My Hotel (SaaS)</>,
        avatar: avatar4,
        image: casestudy5,
        link: '/easemyhotel',
    },
    {
        id: '06',
        Title: <>Dual-Sided Growth for a SaaS Influencer Marketing Platform (US)</>,
        avatar: avatar4,
        image: casestudy6,
        link: '/nicolas',
    },
    {
        id: '07',
        Title: <>Global Expansion & Export Lead Growth for Farmoduct (Agri Exports)</>,
        avatar: avatar4,
        image: casestudy7,
        link: '/farmoduct',
    },
    {
        id: '08',
        Title: <>Local & B2B SEO Expansion for a Singapore Kitchen Cabinet Brand</>,
        avatar: avatar4,
        image: casestudy8,
        link: '/george',
    },
    {
        id: '09',
        Title: <>Local Authority & Year-Round Lead Growth for Arrow Gifter (Corporate Gifting)</>,
        avatar: avatar4,
        image: casestudy9,
        link: '/arrowdifter',
    }
]

const CaseStudiesSlider = () => {
  
    const ClickHandler = () => {
    window.scrollTo(10, 0);
    }

    const settings = {
    dots: false,
    arrows: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
    };

    const slider = React.useRef(null);

  return (

    <section className="intro_about_section section_space pt-0">
        <div className="container">
        
        <div className='row'>
            <div className='col-md-12'>
                <div className="">
                <div className="heading_block text-left">
                    <h2 className="heading_text mb-0">
                        Explore More Case Studies
                    </h2>
                </div>
                <div className="review_4col_carousel swiper">
                    <Slider ref={slider} {...settings}>
                        {testimonial.map((testimonial, tsm) => (
                            <div className="review_block_3" key={tsm}>
                                
                                <img src={testimonial.image} alt="Case Study" style={{width: '100%', height: 'auto', marginBottom: '20px'}} />

                                <div className="review_admin">
                                    <div className="review_admin_info">
                                        <h4 className="review_admin_name review_admin_name_new">{testimonial.Title}</h4>
                                        <Link style={{display:'flex',color:'#000'}} to={testimonial.link}>Learn More &nbsp;&nbsp;<img src={arrowright}/></Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
                </div>
            </div>
        </div>
            
        </div>
    </section>

  );
};

export default CaseStudiesSlider;
